import * as api from "~/api/resource";
import _ from "lodash";
export default {
  props: {},
  data() {
    return {
      _value: "",
      id: null,
      TransDraft: null
    };
  },
  computed: {
    isDirty() {
      return !!this.$data._value;
    }
  },
  watch: {
    "$route.query.selectedTrans": {
      async handler(id, old_id) {
        // _log_('xaxaxaxa',id)
        if (!id) return;
        if (id == old_id) return;
        try {
          const { data } = await api.fetchObject("transdrafts", {
            id: id
          });
          if (data && data.success) this.TransDraft = data.object;
        } catch (error) {
          alert("error loading pricerules:" + val);
        }
      },
      immediate: true
    }
  },
  methods: {
    async updateCommon(classType, val) {
      const classData = { ScheduleTrip: this.ScheduleTrip };
      const data = await api.updateProcessor(
        classType + "/update",
        classData[classType]
      );
      this.$emit("something-changed", { classType: classType, payload: data });
    },
    init() {}
  },
  mounted() {}
};
